import { Component, Input, ViewChild } from '@angular/core';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-ph-swiper',
  templateUrl: './ph-swiper.component.html',
  styleUrls: ['./ph-swiper.component.scss'],
})
export class PhSwiperComponent {
  @Input() config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    effect: 'fade',
    pagination: {
      clickable: true,
    },
  };
  @Input() arrowsType: string = null;
  @ViewChild('swiperEl', { static: true }) swiperEl: SwiperComponent;

  constructor() {}
}
